export const hkHolidays = [
  // 2024 Holidays
  '2024-01-01', // The first day of January (Monday)
  '2024-02-10', // Lunar New Year's Day (Saturday)
  '2024-02-12', // The third day of Lunar New Year (Monday)
  '2024-02-13', // The fourth day of Lunar New Year (Tuesday)
  '2024-03-29', // Good Friday (Friday)
  '2024-03-30', // The day following Good Friday (Saturday)
  '2024-04-01', // Easter Monday (Monday)
  '2024-04-04', // Ching Ming Festival (Thursday)
  '2024-05-01', // Labour Day (Wednesday)
  '2024-05-15', // The Birthday of the Buddha (Wednesday)
  '2024-06-10', // Tuen Ng Festival (Monday)
  '2024-07-01', // Hong Kong Special Administrative Region Establishment Day (Monday)
  '2024-09-18', // The day following the Chinese Mid-Autumn Festival (Wednesday)
  '2024-10-01', // National Day (Tuesday)
  '2024-10-11', // Chung Yeung Festival (Friday)
  '2024-12-25', // Christmas Day (Wednesday)
  '2024-12-26', // The first weekday after Christmas Day (Thursday)

  // 2025 Holidays
  '2025-01-01', // The first day of January (Wednesday)
  '2025-01-29', // Lunar New Year's Day (Wednesday)
  '2025-01-30', // The second day of Lunar New Year (Thursday)
  '2025-01-31', // The third day of Lunar New Year (Friday)
  '2025-04-04', // Ching Ming Festival (Friday)
  '2025-04-18', // Good Friday (Friday)
  '2025-04-19', // The day following Good Friday (Saturday)
  '2025-04-21', // Easter Monday (Monday)
  '2025-05-01', // Labour Day (Thursday)
  '2025-05-05', // The Birthday of the Buddha (Monday)
  '2025-05-31', // Tuen Ng Festival (Saturday)
  '2025-07-01', // Hong Kong Special Administrative Region Establishment Day (Tuesday)
  '2025-10-01', // National Day (Wednesday)
  '2025-10-07', // The day following the Chinese Mid-Autumn Festival (Tuesday)
  '2025-10-29', // Chung Yeung Festival (Wednesday)
  '2025-12-25', // Christmas Day (Thursday)
  '2025-12-26', // The first weekday after Christmas Day (Friday)

  // 2026 Holidays
  '2026-01-01', // The first day of January (Thursday)
  '2026-02-17', // Lunar New Year's Day (Tuesday)
  '2026-02-18', // The second day of Lunar New Year (Wednesday)
  '2026-02-19', // The third day of Lunar New Year (Thursday)
  '2026-04-03', // Good Friday (Friday)
  '2026-04-04', // The day following Good Friday (Saturday)
  '2026-04-06', // The day following Ching Ming Festival (Monday)
  '2026-04-07', // The day following Easter Monday (Tuesday)
  '2026-05-01', // Labour Day (Friday)
  '2026-05-25', // The day following the Birthday of the Buddha (Monday)
  '2026-06-19', // Tuen Ng Festival (Friday)
  '2026-07-01', // Hong Kong Special Administrative Region Establishment Day (Wednesday)
  '2026-09-26', // The day following the Chinese Mid-Autumn Festival (Saturday)
  '2026-10-01', // National Day (Thursday)
  '2026-10-19', // The day following Chung Yeung Festival (Monday)
  '2026-12-25', // Christmas Day (Friday)
  '2026-12-26', // The first weekday after Christmas Day (Saturday)
];

function getHongKongDateParts(date) {
  const parts = new Intl.DateTimeFormat('en-US', {
    timeZone: 'Asia/Hong_Kong',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).formatToParts(date);

  return {
    year: parts.find(part => part.type === 'year').value,
    month: parts.find(part => part.type === 'month').value,
    day: parts.find(part => part.type === 'day').value,
  };
}

function getHongKongDateString(date) {
  const { year, month, day } = getHongKongDateParts(date);
  return `${year}-${month}-${day}`;
}

function getHongKongDay(date) {
  const { year, month, day } = getHongKongDateParts(date);
  return new Date(Date.UTC(Number(year), Number(month) - 1, Number(day))).getUTCDay();
}

export function isHoliday(date) {
  const day = getHongKongDay(date);
  if (day === 0) return true; // Sunday is always a holiday

  const dateString = getHongKongDateString(date);
  return hkHolidays.includes(dateString);
}
